module.exports = __webpack_public_path__ + "media/images/menu/capricornus-45ebbb3a648ae128c5be77194907cd3d.jpg";